import React from 'react';
import { useTranslation } from 'react-i18next';
import { Menu } from 'semantic-ui-react';
import { FaBell } from 'react-icons/fa';
import styled from 'styled-components';

import { UnReadCountLabel } from './UnReadCountLabel';

export type Props = {
  unreadCount: number;
  markArticlesAsRead: () => void;
};

export const Announcement: React.FC<Props> = ({
  unreadCount,
  markArticlesAsRead,
}) => {
  const { t } = useTranslation();
  return (
    <Menu.Item
      className="announcement"
      href={t('pages.external.announcement.url')}
      link={true}
      onClick={markArticlesAsRead}
      rel="noopener noreferrer"
      target="_blank"
    >
      {unreadCount > 0 && <UnReadCountLabel unreadCount={unreadCount} />}

      <StyledFaBell />
    </Menu.Item>
  );
};

const StyledFaBell = styled(FaBell)`
  font-size: 1.5rem;
  margin-right: 7.5px;
`;
